import { PublicDomains } from "../config/publicDomains";

/**
 * Method to check if email domain is valid and not public
 * @param email string
 * @returns boolean
 */
export const IsDomainValid = (email: string): boolean => {
    const domain = GetDomainFromEmail(email);
    if (
        domain.length === 0 ||
        PublicDomains.includes(domain) ||
        PublicDomains.find((d) => d.includes(domain))
    ) {
        return false;
    }
    return true;
};

/**
 * Gets domain from email address
 * @param email
 * @returns string
 */
export const GetDomainFromEmail = (email: string): string => {
    return email.substring(email.lastIndexOf("@") + 1);
};
